import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faShieldHalved,
	faCode,
	faTerminal,
	faCube,
	faGamepad,
	faFutbol,
	faDumbbell,
	faPersonHiking,
} from "@fortawesome/free-solid-svg-icons";
import SectionWrapper from "../components/ui/SectionWrapper";
import { usePortfolioData } from "../contexts/DataContext";
import "./styles/InterestsSection.css";

const iconMap = {
	faShieldHalved,
	faCode,
	faTerminal,
	faCube,
	faGamepad,
	faFutbol,
	faDumbbell,
	faPersonHiking,
};

const staggerContainer = {
	hidden: {},
	visible: {
		transition: { staggerChildren: 0.1, delayChildren: 0.15 },
	},
};

const staggerItem = {
	hidden: { opacity: 0, x: -20 },
	visible: {
		opacity: 1,
		x: 0,
		transition: { duration: 0.5, ease: "easeOut" },
	},
};

const InterestsSection = () => {
	const { data: INFO } = usePortfolioData();
	return (
		<SectionWrapper id="interests" className="interests-section">
			<div className="content-wrapper">
				<h2 className="section-title">
					Stuff I'm into
				</h2>
				<p className="section-subtitle">
					When I'm not at work, this is where my time goes.
				</p>

				<motion.div
					className="interests-list"
					variants={staggerContainer}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true, amount: 0.1 }}
				>
					{INFO.interests.map((interest, index) => (
						<motion.div
							key={index}
							className="interest-row"
							variants={staggerItem}
						>
							<div className="interest-row__icon">
								<FontAwesomeIcon
									icon={iconMap[interest.icon] || faCode}
								/>
							</div>
							<div className="interest-row__content">
								<h3 className="interest-row__title">
									{interest.title}
								</h3>
								<p className="interest-row__description">
									{interest.description}
								</p>
							</div>
							<span className="interest-row__number">
								{String(index + 1).padStart(2, "0")}
							</span>
						</motion.div>
					))}
				</motion.div>
			</div>
		</SectionWrapper>
	);
};

export default InterestsSection;
